<template>
  <b-table
    :data="questionSets"
    paginated
    pagination-simple
    :debounce-search="200"
  >
    <b-table-column
      field="name"
      label="Name"
      v-slot="props"
      :searchable="isSearchable"
      sortable
    >
      {{ props.row.name }}
    </b-table-column>

    <b-table-column field="last_name" label="Actions" v-slot="props">
      <inertia-link :href="route('question-sets.show', props.row.unique_id)">
        <b-button type="is-primary" size="is-small">Edit</b-button>
      </inertia-link>
    </b-table-column>
  </b-table>
</template>

<script>
export default {
  props: {
    questionSets: Array,
  },
  data() {
    return {
      isEmpty: false,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isHoverable: false,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
    };
  },
  computed: {
    isSearchable: function () {
      return this.questionSets.length > 10;
    },
  },
};
</script>
